import React from "react";

import NavbarLeft from "./NavbarLeft";
import NavbarRight from "./NavbarRight";
import "./NavbarHome.css";
import "./NavbarMain.css";

import { connect } from "react-redux";
import { logout, loginUser } from "../../reducers/user";

import { ReactComponent as HouseIcon } from "../../icons/house-bold.svg";
import { ReactComponent as UserIcon } from "../../icons/user-circle-bold.svg";
import { ReactComponent as ArrowDown } from "../../icons/arrow-down-bold.svg";
class Navbar extends React.Component {
  state = {
    left: [],
    right: [],
  };
  componentDidMount() {
    this.props.loginUser();
    this._renderLinks(window.location.pathname);
  }
  componentDidUpdate(oldProps) {
    if (oldProps.location !== this.props.location) {
      this._renderLinks(this.props.location);
    }
    if (!!oldProps.user !== !!this.props.user) {
      this._renderLinks(this.props.location);
    }
  }
  _handleLogout = () => {
    this.props.logout();
    window.location.href = "/";
  };
  _renderLinks = (location) => {
    switch (location) {
      case "":
      case "/":
        this.setState({
          style: "navbar-home",
          left: [
            // { target: "/", label: "Funzionalità" },
            // { target: "/", label: "Esplora" },
            // { target: "/", label: "Abbonamenti" },
            { target: "/templates", label: "Templates" },
          ],
          right: [
            { target: "/mystores", label: "Crea il tuo sito" },
            { target: "/login", label: "Accedi", button: "button-home" },
          ],
        });
        break;
      case "/templates":
      case "/mystores":
      case "/settings":
      case (location.match(/editor/) || {}).input:
        this.props.user
          ? this.setState({
              style: "navbar-main",
              left: [
                // { target: "/", label: "Funzionalità" },
                { target: "/templates", label: "Templates" },
                // { target: "/assistenza", label: "Assistenza" },
              ],
              right: [
                {
                  target: "/mystores",
                  label: "I miei siti",
                  leftIcon: <HouseIcon />,
                },
                {
                  username: `${this.props.user.firstname.charAt(
                    0
                  )}. ${this.props.user.lastname.charAt(0)}.`,
                  logout: this._handleLogout,
                  leftIcon: <UserIcon />,
                  rightIcon: <ArrowDown />,
                },
              ],
            })
          : this.setState({
              style: "navbar-main",
              left: [
                // { target: "/", label: "Funzionalità" },
                // { target: "/", label: "Esplora" },
                // { target: "/", label: "Abbonamenti" },
                { target: "/templates", label: "Templates" },
              ],
              right: [
                { target: "/login", label: "Accedi", button: "buttonAccess" },
              ],
            });
        break;
      case "/login":
      case "/register":
      case "/newPasswordRequest":
        this.setState({
          style: "navbar-home",
          left: [],
          right: [],
        });
        break;

      default:
        break;
    }
  };
  render() {
    return (
      <navbar className={this.state.style}>
        <NavbarLeft user={this.props.user} links={this.state.left} />
        <NavbarRight links={this.state.right} />
      </navbar>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.user.data.user,
  authToken: state.user.data.authToken,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, { logout, loginUser })(Navbar);
